module.exports = __webpack_public_path__ + "static/EnmTX_BosOlric_L_A_cl-a21a84a7be72ad91a32c66b73526543f.gif";